import { oc } from 'ts-optchain';
import _ from 'lodash';

import { core, safeEnumCompare } from '@tock/coretypes';
import AppSettings from 'settings/AppSettings';
import protos from 'utils/protos';

const { PaymentProcessorType } = protos;

export function isBraintreeProcessorType(processorType: core.PaymentProcessorType): boolean {
  return safeEnumCompare(processorType, PaymentProcessorType, PaymentProcessorType.BRAINTREE);
}

export function hasBraintreeTransaction(changeHistory: core.PurchaseChangeHistory[]): boolean {
  return _.some(changeHistory, (history) => {
    return isBraintreeProcessorType(history.processorType);
  });
}

export function isBraintreeTransaction(purchaseDetails: core.PastPurchase): boolean {
  return hasBraintreeTransaction(purchaseDetails.changeHistory as core.PurchaseChangeHistory[]);
}

/**
 * Generates the link to Braintree given details about the purchase transaction.
 * @param {array} changeHistory all of the changes made on a purchase
 * @param {string} confirmationId the confirmation id of the pruchase
 * @returns {string} the URL to the Braintree transaction details, or undefined if it can't be computed
 */
export function getBraintreeTransactionUrl(
  changeHistory: core.IPurchaseChangeHistory[],
  confirmationId: string,
  businessId: number
): string | undefined {
  const braintreeTransaction = _.find(changeHistory as core.PurchaseChangeHistory[], (history) => {
    return (
      history.referenceId &&
      history.referenceId.toLowerCase().endsWith(confirmationId.toLowerCase()) &&
      history.amountPaidCents > 0
    );
  });
  if (!braintreeTransaction) {
    return undefined;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const purchaseId = oc(braintreeTransaction as any).purchaseId();
  return `${AppSettings.API_BASE}/payment/link?purchaseId=${purchaseId}&businessId=${businessId}`;
}
